const axios = require(/*! axios */"../../kru_node_modules/axios/index.js");
const config = require(/*! ../config.js */"../config.js");
const apiUrl = config.apiURL;
const apiClient = {
  // SEND MAP LIST:
  listMaps(index, accountId, callback) {
    axios.get(apiUrl + "/maps", {
      params: {
        index: index,
        accountId: accountId
      }
    }).then(response => {
      callback(null, response.data);
    }).catch(error => {
      callback(error, error.response && error.response.data);
    });
  },
  // SEND MOD LIST:
  listMods(accountId, callback) {
    axios.get(apiUrl + "/mods", {
      params: {
        accountId: accountId
      }
    }).then(response => {
      callback(null, response.data);
    }).catch(error => {
      callback(error, error.response && error.response.data);
    });
  },
  // SEARCH MAPS:
  searchMap(val, callback) {
    axios.get(apiUrl + "/search", {
      params: {
        type: "map",
        val: val
      }
    }).then(response => {
      callback(null, response.data);
    }).catch(error => {
      callback(error, error.response && error.response.data);
    });
  },
  // GET MAP PRESET:
  getMapPreset(mapName, callback) {
    axios.get(apiUrl + "/config", {
      params: {
        mn: mapName
      }
    }).then(response => {
      var tmpDt = response.data || {};
      callback(mapName, tmpDt.da);
    }).catch(error => {
      callback(mapName, null);
    });
  },
  // SEARCH MOD:
  searchMod(val, callback) {
    axios.get(apiUrl + "/search", {
      params: {
        type: "mod",
        val: val
      }
    }).then(response => {
      callback(null, response.data);
    }).catch(error => {
      callback(error, error.response && error.response.data);
    });
  }
};
module.exports = apiClient;